import { Subscription } from "rxjs";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';

import swal from "bootstrap-sweetalert";

import { ProfileService } from "app/services/profile.service";
import { NewPasswordComponent, PasswordChangeData } from "../asset/newPassword/newPassword-form.component";

@Component({
  templateUrl: "activate.component.html",
  styleUrls: ["activate.component.scss"]
})
export class ActivateComponent implements OnInit {

  @ViewChild('newPassword') newPasswordComponent:NewPasswordComponent;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _profileService: ProfileService,
    private _router: Router) { }

  ngOnInit() {
    this._activatedRoute
      .queryParams
      .subscribe(params => {
        this.token = params['token'];
      });
  }

  private _activateSubscription: Subscription = null;
  activateUser(data : PasswordChangeData) {
    this._activateSubscription = this._profileService.activateUser(data.newPassword, this.token)
      .subscribe(_ => {
        swal('Ок', 'Активация учётной записи успешно выполнена', 'success');
        this._router.navigate(['/call/list']);
      },
      error => {
        switch (error as ProfileService.ActivateTokenError) {
          case "TemporaryTokenDateIsExpired":
            this._activationError = 'Срок действия токена истёк';
            break;
          case "UserIsActivated":
            this._activationError = 'Пользователь уже является активированным';
            break;
          case "UserWithEmailExist":
            this._activationError = 'Пользователь с таким email уже существует';
            break;
          default:
            this._activationError = 'При активации произошла ошибка. Токен является недействительным';
        }
      },
      () => {
        this.newPasswordComponent.clearFileds();
      });
  }

  private _activationError: string = null;

  token: string;

}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/activate/activate.component.ts